module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Camera-0d009be63e5b91e53e90f9ea0d3873fd.svg";